import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import CloseIcon from '@/components/v3/CloseIcon.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
/**
 * Modal
 * @author Jan Canicon <jan@gorated.ph>
 *                     <jancanicon.work@gmail.com>
 * @since Version {2.19.13}
 *
 * Docs: https://gorated.atlassian.net/wiki/spaces/DMDS/pages/1814921231/Modal
 */
let Modal = class Modal extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.dialog = this.value;
        this.contentIsIframe = false;
    }
    onValueChanged() {
        this.dialog = this.value;
    }
    onDialogChanged() {
        if (!this.dialog) {
            this.$emit('onClose');
            const iframe = document.querySelector('.iframe-container iframe');
            // Pause video https://stackoverflow.com/a/49172832
            // eslint-disable-next-line no-unused-expressions
            iframe?.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'stopVideo' }), '*');
        }
    }
    get modalWidth() {
        if (this.lgAndUp) {
            return this.width;
        }
        if (this.mdOnly) {
            return this.mdWidth;
        }
        if (this.smOnly) {
            return this.smWidth;
        }
        return this.xsWidth;
    }
    openModal() {
        this.dialog = true;
    }
    closeModal() {
        this.dialog = false;
        this.$emit('closeModal');
    }
    mounted() {
        if (this)
            this.contentIsIframe = this?.$slots?.content?.[0]?.tag === 'iframe';
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], Modal.prototype, "value", void 0);
__decorate([
    Prop({ type: String, default: '40vw' })
], Modal.prototype, "width", void 0);
__decorate([
    Prop({ type: String, default: '55vw' })
], Modal.prototype, "mdWidth", void 0);
__decorate([
    Prop({ type: String, default: '65vw' })
], Modal.prototype, "smWidth", void 0);
__decorate([
    Prop({ type: String, default: '100vw' })
], Modal.prototype, "xsWidth", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], Modal.prototype, "persistent", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], Modal.prototype, "noCloseButton", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], Modal.prototype, "lazy", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], Modal.prototype, "vertical", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], Modal.prototype, "preventClose", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], Modal.prototype, "noPadding", void 0);
__decorate([
    Watch('value')
], Modal.prototype, "onValueChanged", null);
__decorate([
    Watch('dialog')
], Modal.prototype, "onDialogChanged", null);
Modal = __decorate([
    Component({
        name: 'Modal',
        components: {
            CloseIcon,
        },
    })
], Modal);
export default Modal;
